
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import Component from "vue-class-component";
import Vue from "vue";
import MedicalCertificatesTable from "../components/MedicalCertificatesTable.vue";

@Component({
    components: {
        HeadingWave,
        MedicalCertificatesTable
    }
})
export default class MedicalCertificates extends Vue {
}
